import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Linkedin, Youtube, MessageCircle } from 'lucide-react';
import { useImages } from '../hooks/useImages';

const LOGO_DEFAULT = 'https://customer-assets.emergentagent.com/job_soil-to-soul-2/artifacts/i9fai1ns_WhatsApp_Image_2026-03-16_at_10.39.52_AM-removebg-preview.png';

const Footer = () => {
  const siteImages = useImages();
  const logo = siteImages['site-logo'] || LOGO_DEFAULT;
  const ecosystemLinks = [
    { name: 'Organic Hues', path: '/organic-hues' },
    { name: 'Green Horizon', path: '/green-horizon' },
    { name: 'EcoRoute', path: '/ecoroute' },
    { name: 'WHeros', path: '/wheros' },
    { name: 'Rise & Rolls', path: '/rise-and-rolls' }
  ];

  const quickLinks = [
    { name: 'About Us', path: '/' },
    { name: 'Franchise Inquiry', path: '/' },
    { name: 'Partner With Us', path: '/' },
    { name: 'Careers', path: '/' },
    { name: 'Contact', path: '/' }
  ];

  return (
    <>
      <footer className="bg-[#2C1810] text-[#F5EDE4]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="lg:col-span-1">
              <img
                src={logo}
                alt="Nistala's Group"
                className="h-40 w-auto mb-6"
              />
              <p className="text-sm text-[#F5EDE4]/70 mb-6 leading-relaxed">
                From Soil to Soul - A women-led, AI-powered ecosystem transforming food, farming, and livelihoods across India.
              </p>
              <div className="flex space-x-4">
                {[Facebook, Twitter, Instagram, Linkedin, Youtube].map((Icon, i) => (
                  <a key={i} href="#" className="text-[#F5EDE4]/40 hover:text-[#D4A574] transition-colors duration-300">
                    <Icon size={18} />
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h3 className="text-base font-semibold mb-4 text-[#D4A574]">Our Ecosystem</h3>
              <ul className="space-y-3">
                {ecosystemLinks.map((link) => (
                  <li key={link.path + link.name}>
                    <Link to={link.path} className="text-sm text-[#F5EDE4]/70 hover:text-[#D4A574] transition-colors duration-200">{link.name}</Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-base font-semibold mb-4 text-[#D4A574]">Quick Links</h3>
              <ul className="space-y-3">
                {quickLinks.map((link, i) => (
                  <li key={i}>
                    <Link to={link.path} className="text-sm text-[#F5EDE4]/70 hover:text-[#D4A574] transition-colors duration-200">{link.name}</Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-base font-semibold mb-4 text-[#D4A574]">Get in Touch</h3>
              <div className="space-y-4 text-sm text-[#F5EDE4]/70">
                <p><strong className="text-[#F5EDE4]">Email:</strong><br /><a href="mailto:info@nistalasoh.com" className="hover:text-[#D4A574] transition-colors">info@nistalasoh.com</a></p>
                <p><strong className="text-[#F5EDE4]">Toll Free:</strong><br /><a href="tel:180056934335" className="hover:text-[#D4A574] transition-colors">1800-5693-4335</a></p>
                <p><strong className="text-[#F5EDE4]">Address:</strong><br />Hyderabad, Telangana, India</p>
              </div>
            </div>
          </div>

          <div className="border-t border-[#F5EDE4]/10 mt-8 pt-6 flex items-center justify-between">
            <p className="text-xs text-[#F5EDE4]/40">
              &copy; 2025 Nistala's Group. All rights reserved.
            </p>
            <Link to="/admin" data-testid="footer-admin-link" className="text-xs text-[#F5EDE4]/25 hover:text-[#D4A574]/60 transition-colors duration-300">
              Admin
            </Link>
          </div>
        </div>
      </footer>

      <a
        href="https://wa.me/91XXXXXXXXXX?text=Hello%20Nistala's%20Group!%20I'd%20like%20to%20know%20more%20about%20your%20ecosystem."
        target="_blank" rel="noopener noreferrer"
        data-testid="whatsapp-btn"
        className="fixed bottom-6 right-6 z-50 bg-[#25D366] hover:bg-[#20BA5A] text-white p-3.5 rounded-full shadow-xl shadow-[#25D366]/30 transition-all duration-300 hover:scale-110"
        aria-label="Chat on WhatsApp"
      >
        <MessageCircle size={26} />
      </a>
    </>
  );
};

export default Footer;
